import React, { Fragment } from "react"

export const nl2br = text =>
	typeof text === "string"
		? text.split("\n").reduce((prevLine, nextLine) => (
				<Fragment>
					{prevLine}
					<br />
					{nextLine}
				</Fragment>
		  ))
		: text

export const copyToClipboard = text => {
	if (document) {
		const el = document.createElement("textarea")
		el.value = text
		el.setAttribute("readonly", "")
		el.style.position = "absolute"
		el.style.left = "-99999px"
		document.body.appendChild(el)
		el.select()
		document.execCommand("copy")
		document.body.removeChild(el)
	}
}

export const toast = (text, duration) => {
	document.dispatchEvent(
		new CustomEvent("toast", {
			detail: {
				message: text,
				duration: duration || 1500
			}
		})
	)
}

export const getParams = () => {
	if (window && window.location.search.length > 0) {
		return window.location.search
			.substr(1)
			.split("&")
			.reduce((params, currentVal) => {
				const [key, value] = currentVal.split("=")
				return {
					...params,
					[key]: decodeURIComponent(value)
				}
			}, {})
	}

	return {}
}

export const setParams = object => {
	const keys = Object.keys(object)
	history.pushState(
		{},
		document.title,
		`${window.location.pathname}?${keys.reduce(
			(paramString, key) =>
				`${paramString}${
					paramString.length ? "&" : ""
				}${key}=${encodeURIComponent(object[key])}`,
			[]
		)}`
	)
}

export const clearParams = () => setParams({})

export const setParam = (key, value) => {
	const params = getParams()
	setParams({
		...params,
		[key]: value
	})
}

export const createSlug = (title, id) =>
	title
		.toLowerCase()
		.replace(/[^a-z0-9 -]/gi, "")
		.replace(/ /g, "-") + (id ? `-${id}` : "")

export const makeTemporalSortIndex = temporalString => {
	const [date, time] = temporalString.split("T")
	const negative = date.startsWith("-")
	const [year, month, day] = (negative ? date.substr(1) : date).split("-")
	const [hour, minute, seconds] = time.split(":")
	return parseInt(
		parseInt(year * (negative ? -1 : 1)).toString() +
			[month, day, hour, minute, seconds].reduce(
				(x, n) => x + n.padStart(2, "0"),
				""
			)
	)
}

export const temporalToYear = temporalString => {
	const [date, time] = temporalString.split("T")
	const negative = date.startsWith("-")
	const [year, month, day] = (negative ? date.substr(1) : date).split("-")
	// Make a (negative) year in the past positive, since years before present already implies a year in the past
	return parseInt(year * (negative ? 1 : -1)).toString()
}



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/utils/index.js